import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonItem,
  IonLabel,
  IonList,
  IonSelect,
  IonSelectOption,
  IonToggle,
  IonSpinner,
} from "@ionic/react";

import { FormattedMessage } from "react-intl";

//Inferfaces
import { User, Settings } from "../../../interfaces";

import {
  IconPlug,
  IconPlugConnected,
  IconSwitchHorizontal,
  IconUser,
  IconLogout,
  IconLanguage,
  IconCreditCard,
  IconUserCircle,
  IconBell,
  IconCreditCardPay,
  IconChartLine,
} from "@tabler/icons-react";

import config from "../../../config";
import headerStyles from "../../../theme/header.module.css";

// Providers
import { usePushNotifications } from "../../../providers/native-push-notification";
import { useAuth } from "../../../providers/auth";

const Header = () => {
  return (
    <div>
      <div className={headerStyles.header}>
        <h1 className={headerStyles.mobileTitle}>
          <FormattedMessage id="settings.pageTitle" />
        </h1>
        <h3 className={headerStyles.mobileDescription}>
          <FormattedMessage id="settings.pageDescription" />
        </h3>
      </div>
    </div>
  );
};

const MobileSettings: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  const { user, settings, switchCompany } = props;
  const { state, toggleNotifications, loading, userPush } =
    usePushNotifications();

  const { logout } = useAuth();
  const isAdmin = user.role === "admin" || user.role === "system";

  return (
    <IonPage id="main-content">
      <IonHeader>
        <IonToolbar>
          <IonTitle>
            <FormattedMessage id="settings.pageTitle" />
          </IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen color="light">
        <div className="view-wrapper">
          <div className="view-pane">
            <Header />
          </div>

          <IonList inset={true}>
            <IonItem>
              <div slot="start">
                <IconUser />
              </div>
              <IonLabel>{user.email}</IonLabel>
            </IonItem>
            {settings.multiAccount ? (
              <IonItem>
                <div slot="start">
                  <IconSwitchHorizontal />
                </div>
                <IonSelect
                  label={"Account"}
                  placeholder="Make a Selection"
                  value={settings.company.id}
                  onIonChange={(e) =>
                    switchCompany({ companyId: e.target.value })
                  }
                >
                  {settings.companies.map((c) => (
                    <IonSelectOption value={c.id} key={c.id}>
                      {c.name}
                    </IonSelectOption>
                  ))}
                </IonSelect>
              </IonItem>
            ) : null}
          </IonList>

          <IonList inset={true}>
            {settings.paymentsEligible && isAdmin ? (
              <IonItem button routerLink={`/payments`} detail={true}>
                <div slot="start">
                  <IconCreditCardPay />
                </div>
                <IonLabel>
                  <FormattedMessage id="nav.payments" />
                </IonLabel>
              </IonItem>
            ) : null}
            {isAdmin && (
              <IonItem button routerLink={`/integrations`} detail={true}>
                <div slot="start">
                  <IconPlugConnected />
                </div>
                <IonLabel>
                  <FormattedMessage id="settings.integrations" />
                </IonLabel>
              </IonItem>
            )}
            {isAdmin && (
              <IonItem button routerLink={`/connect`} detail={true}>
                <div slot="start">
                  <IconPlug />
                </div>
                <IonLabel>
                  <FormattedMessage id="settings.connect" />
                </IonLabel>
              </IonItem>
            )}
          </IonList>
          <IonList inset={true}>
            <IonItem button routerLink={`/settings/language`} detail={true}>
              <div slot="start">
                <IconLanguage />
              </div>
              <IonLabel>
                <FormattedMessage id="settings.language" />
              </IonLabel>
            </IonItem>
            {isAdmin && (
              <IonItem button routerLink={`/settings/team`} detail={true}>
                <div slot="start">
                  <IconUserCircle />
                </div>
                <IonLabel>
                  <FormattedMessage id="settings.teams" />
                </IonLabel>
              </IonItem>
            )}
            {isAdmin && (
              <IonItem button routerLink={`/settings/payment`} detail={true}>
                <div slot="start">
                  <IconCreditCard />
                </div>
                <IonLabel>
                  <FormattedMessage id="settings.payment" />
                </IonLabel>
              </IonItem>
            )}
            {isAdmin && (
              <IonItem button routerLink={`/settings/usage`} detail={true}>
                <div slot="start">
                  <IconChartLine />
                </div>
                <IonLabel>
                  <FormattedMessage id="settings.usage" />
                </IonLabel>
              </IonItem>
            )}
          </IonList>
          {!["not_supported", "error"].includes(state) && (
            <IonList inset={true}>
              <IonItem>
                <div slot="start">
                  <IconBell />
                </div>
                <IonLabel>
                  <FormattedMessage id="nav.notifications" />

                  <p>
                    <FormattedMessage
                      id={
                        state === "denied"
                          ? "settings.pushNotificationsDenied"
                          : "settings.pushNotificationsDescription"
                      }
                    />
                  </p>
                </IonLabel>
                {loading ? (
                  <IonSpinner name="dots" />
                ) : state !== "denied" ? (
                  <div slot="end">
                    <IonToggle
                      checked={userPush.active}
                      onIonChange={(ev) => {
                        toggleNotifications(ev.detail.checked);
                      }}
                    ></IonToggle>
                  </div>
                ) : (
                  <></>
                )}
              </IonItem>
            </IonList>
          )}
          <IonList inset={true}>
            <IonItem button onClick={logout} detail={true}>
              <div slot="start">
                <IconLogout />
              </div>
              <IonLabel>
                <FormattedMessage id="nav.logout" />
              </IonLabel>
            </IonItem>
          </IonList>

          <div className="view-pane color-step-500">
            {config.VERSION.vIdentifier}
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

interface ILayoutProps {
  switchCompany: Function;
  user: User;
  settings: Settings;
}

/*


 {settings.events ? (
            <IonTabButton
              className="visito-tabs"
              tab="outbound"
              href="/outbound"
            >
              <IconOutbound size={26} />
              <IonLabel>
                {" "}
                <FormattedMessage id="nav.outbound" />
              </IonLabel>
            </IonTabButton>
          ) : null}
           */

export default MobileSettings;
